export const cropHealthEs = {
  cropHealth: {
    title: "Panel de Salud del Cultivo",
    noDataAvailable: "Sin Datos Disponibles",
    noDataDesc: "Los datos de salud del cultivo no están disponibles actualmente para esta parcela. Se requieren fuentes de datos reales para el análisis.",
    geographicAnalysis: "Análisis geográfico de plagas y recomendaciones para tu cultivo de {{crop}} en {{lat}}, {{lon}}",
    overview: "📊 Resumen",
    pestsAndDiseases: "🐛 Plagas y Enfermedades",
    irrigation: "💧 Riego",
    harvest: "🌾 Cosecha",
    imageAnalysis: "📷 Análisis de Imagen",
    overallHealth: "Salud General",
    excellentHealth: "Salud Excelente",
    moderateHealth: "Salud Moderada",
    poorHealth: "Salud Deficiente",
    highRiskPests: "Plagas de Alto Riesgo",
    pestsAnalyzed: "Plagas Analizadas",
    currentClimate: "Condiciones Climáticas Actuales",
    temperature: "Temperatura",
    humidity: "Humedad",
    precipitation: "Precipitación",
    geographicPestAlert: "Análisis geográfico de plagas basado en tu ubicación y datos climáticos en tiempo real para el cultivo de {{crop}}.",
    verifyBeforeTreatment: "Múltiples Fuentes de Datos - Verificar Antes de Cualquier Intervención",
    officialSources: "Fuentes Oficiales (🟢 EPPO, 🟡 CABI):",
    officialSourcesDesc: "Bases de datos verificadas de instituciones oficiales.",
    aiResearch: "Investigación IA (🔵 Perplexity):",
    aiResearchDesc: "Información generada por IA basada en literatura científica.",
    consultAgronomist: "No verificado por instituciones oficiales. Consulta con tu asesor agronómico antes de cualquier decisión de intervención.",
    climateRiskNote: "Las puntuaciones de riesgo climático se calculan usando datos meteorológicos reales y pueden variar.",
    geographicPestRisk: "Evaluación Geográfica de Riesgo de Plagas",
    activeThisMonth: "Activa este mes",
    inactiveSeason: "Temporada inactiva",
    optimalConditions: "Condiciones óptimas",
    climateCorrelation: "Correlación Climática",
    prevention: "Prevención",
    treatmentOptions: "Opciones de revisión",
    noPestRisks: "No se detectaron riesgos significativos de plagas para tu ubicación y tipo de cultivo.",
    geographicDiseaseRisk: "Evaluación Geográfica de Riesgo de Enfermedades",
    soilMoistureAnalysis: "Análisis de Humedad del Suelo",
    realData: "🛰️ Datos Reales",
    simulated: "Simulado",
    currentSoilMoisture: "Humedad Actual del Suelo",
    optimal: "Óptimo",
    irrigationRecommendation: "Recomendación de Riego",
    nextIrrigation: "Próximo Riego",
    estimatedVolume: "Volumen Estimado",
    criticalWaterStress: "Estrés hídrico crítico detectado. ¡Riego inmediato requerido!",
    highWaterStress: "Estrés hídrico alto detectado. Riego necesario en 24 horas.",
    waterStressDetected: "Estrés hídrico detectado. Aumentar frecuencia de riego.",
    environmentalConditions: "Condiciones Ambientales",
    soilMoistureStatus: "Estado de Humedad del Suelo",
    waterStressLevel: "Nivel de Estrés Hídrico",
    dataSource: "Fuente de Datos",
    realTimeSatellite: "🛰️ Satélite en Tiempo Real",
    simulatedData: "📊 Simulado",
    realDataNote: "Humedad del suelo de datos satelitales NASA",
    simulatedDataNote: "Considera actualizar a monitoreo de humedad del suelo en tiempo real para decisiones de riego precisas",
    harvestPrediction: "Predicción de Cosecha",
    estimatedHarvestDate: "Fecha Estimada de Cosecha",
    qualityForecast: "Pronóstico de Calidad",
    yieldEstimate: "Estimación de Rendimiento",
    harvestDataSourceNote: "Predicciones basadas en {{source}}",
    realCropData: "datos reales de NDVI, clima y meteorología",
    simulatedCropData: "patrones simulados de salud del cultivo",
    harvestAlert: "Las predicciones de cosecha se basan en la salud actual del cultivo, patrones meteorológicos y datos históricos para {{crop}} en tu región.",
    aiCropDiagnosis: "Diagnóstico de Cultivos con IA",
    aiCropDiagnosisDesc: "Sube una foto clara de tu cultivo para obtener un diagnóstico instantáneo de plagas y enfermedades con IA",
    removeImage: "Eliminar Imagen",
    analyzeImage: "Analizar Imagen",
    analyzing: "Analizando...",
    uploadCropImage: "Subir Imagen del Cultivo",
    supportedFormats: "Formatos soportados: JPEG, PNG, WebP (Máx 10MB)",
    analyzingCropImage: "Analizando Imagen del Cultivo",
    analyzingCropImageDesc: "La IA está examinando la imagen en busca de plagas, enfermedades y deficiencias nutricionales...",
    analyzingTime: "Esto normalmente tarda 15-30 segundos",
    aiDiagnosisComplete: "Diagnóstico IA Completado",
    imageTip: "Para mejores resultados, toma fotos claras de hojas, tallos o frutos afectados con buena iluminación. La IA puede ayudar al diagnóstico visual del cultivo y sugerir posibles problemas. Valida los resultados con scouting de campo antes de cualquier decisión de intervención.",
    invalidFileType: "Tipo de archivo inválido",
    invalidFileTypeDesc: "Sube un archivo de imagen (JPEG, PNG, etc.)",
    fileTooLarge: "Archivo demasiado grande",
    fileTooLargeDesc: "Sube una imagen menor a 10MB",
    analysisComplete: "Análisis completado",
    analysisCompleteDesc: "Imagen analizada exitosamente",
    analysisFailed: "Análisis fallido",
    analysisFailedDesc: "Error al analizar imagen. Inténtalo de nuevo.",
    calculationNote: "Basado en puntuaciones promedio de riesgo de plagas y enfermedades. Fórmula: 100 - (riesgos de plagas + riesgos de enfermedades + penalización de riego)",
    irrigationTimingMovedNote: "Este panel muestra solo la humedad del suelo observada y el estado de estrés hídrico. Abre el módulo de Riego para la programación y el volumen.",
    legacyCompositeTitle: "Indicador compuesto heredado de salud del cultivo — solo referencia",
    legacyCompositeNote: "Este compuesto mezcla señales no relacionadas (puntuaciones de catálogo de plagas, de enfermedades y una penalización por estrés hídrico). No es el estado canónico de riesgo fitosanitario local: consulta la cabecera de estado fitosanitario del módulo de Plagas y Enfermedades para la conclusión a nivel de parcela.",
    catalogueHighRiskPests: "Plagas de catálogo marcadas como riesgo alto (referencia)",
    catalogueReferenceOnly: "Indicador externo de referencia — no conectado al estado canónico de la parcela",
    weatherReferenceNote: "Los porcentajes de estas tarjetas geográficas son indicadores externos de catálogo/meteorología de referencia. No son la idoneidad meteorológica canónica de la parcela.",
    calculationLabel: "Cálculo",
    dataSourcesLabel: "Fuentes de datos",
    realtimeClimateLabel: "Clima en tiempo real",
    harvestCalculationBreakdown: "Desglose del cálculo",
    harvestBaseYield: "Rendimiento base",
    harvestNdviAdjustment: "Ajuste NDVI",
    harvestWeatherAdjustment: "Ajuste meteorológico",
    harvestStressAdjustment: "Ajuste por estrés",
    harvestRiskFactors: "Factores de riesgo",
    harvestReviewNotes: "Notas de revisión",
    harvestConfidence: "de confianza",
    harvestNdviPoints: "NDVI: {{count}} puntos",
    harvestWeatherSource: "Meteorología: {{source}}",
    harvestNutrientReviewNote: "Revisa un posible estrés nutricional con la evidencia actual de suelo/foliar y un asesor agronómico cualificado.",
    harvestSource: {
      simulated: "Modelo simulado",
      ai_model: "Modelo IA — datos reales de satélite y meteorología"
    },
    waterStress: {
      none: "Ninguno",
      mild: "Leve",
      moderate: "Moderado",
      severe: "Severo"
    },
    quality: {
      excellent: "Excelente",
      good: "Buena",
      average: "Media",
      belowAverage: "Por debajo de la media",
      poor: "Baja",
      unknown: "Desconocida"
    },
    crops: {
      wheat: "Trigo",
      barley: "Cebada",
      corn: "Maíz",
      maize: "Maíz",
      sunflower: "Girasol",
      olive: "Olivar",
      vineyard: "Viñedo",
      almond: "Almendro",
      citrus: "Cítricos",
      rice: "Arroz",
      potato: "Patata",
      tomato: "Tomate"
    },
    aiReasoning: "Razonamiento de la IA",
    dataQualityHigh: "Datos de alta calidad",
    dataQualityMedium: "Datos de calidad media",
    dataQualityLimited: "Datos limitados",
    moistureStatus: {
      critical: "Estado crítico",
      low: "Estado bajo",
      optimal: "Estado óptimo",
      high: "Estado alto"
    },
    noImageSelected: "Sin imagen seleccionada",
    noImageSelectedDesc: "Sube una imagen primero"
  },
  cropHealthWater: {
    externalReferenceBadge: "Indicador externo de referencia",
    externalReferenceNote:
      "Respuesta en vivo del proveedor (NASA POWER). Es un indicador externo de humedad de referencia; no es evidencia persistida de la parcela ni evidencia canónica de estrés hídrico. No se usa para habilitar puertas FAO-56 ni para programar o ejecutar riego."
  },
  pestRisk: {
    levels: {
      high: "Riesgo alto",
      medium: "Riesgo moderado",
      low: "Riesgo bajo",
      minimal: "Riesgo mínimo"
    },
    indicator: {
      epidemiological_model: "Modelo epidemiológico",
      weather_conditions: "Indicador de idoneidad meteorológica"
    },
    treatmentDecisionNote: "Las decisiones de control requieren revisión de tu asesor agronómico. SentinelCrop no sugiere productos, dosis ni aplicaciones.",
    consultAgronomist: "Consulta a tu asesor agronómico para las decisiones de control."
  }
};

export const pestCanonicalEs = {
  pestCanonical: {
    headerTitle: "Estado fitosanitario",
    epidemiologicalRisk: "Riesgo epidemiológico",
    weatherSuitability: "Idoneidad meteorológica",
    evidenceConfidence: "Confianza de la evidencia",
    fieldConfirmation: "Confirmación en campo",
    notAvailable: "No disponible",
    confidence: {
      high: "Alta",
      medium: "Media",
      low: "Baja",
      data_limited: "Datos limitados"
    },
    confidenceCapNote: "La confianza no puede ser Alta sin scouting de campo y una señal de estado fenológico del cultivo.",
    waterEvidenceNote: "No hay evidencia hídrica de ámbito parcela disponible. Puede existir un indicador externo de humedad de referencia en Salud del Cultivo, pero no es evidencia persistida de la parcela y no se usa en esta evaluación de riesgo.",
    weatherNotConnectedNote: "La idoneidad meteorológica aún no está conectada a esta parcela. Los porcentajes de las tarjetas geográficas de plagas son valores externos de referencia y no alimentan este estado canónico.",
    confirmation: {
      confirmed: "Confirmado en campo",
      not_confirmed: "Revisado, sin incidencia reportada",
      missing: "Sin confirmación en campo"
    },
    gddFreshness: {
      current: "Actualizado",
      recent: "Reciente",
      stale: "Desactualizado",
      missing: "No disponible"
    },
    gddAsOf: "a fecha {{date}}",
    gddStaleHint: "La acumulación de GDD almacenada no se ha recalculado recientemente, por lo que puede no coincidir con las señales de riesgo actuales.",
    gddSourceLabel: "Fuente"
  }
};
